import { EMfaMethod, schemes } from "@zeal/common";
import { z } from "zod";

export const updateWorkerMfaMethodRequestSchema = z.object({
  email: schemes.email(),
  mfaMethod: z.array(z.nativeEnum(EMfaMethod)),
});

export type TUpdateWorkerMfaMethodRequest = z.infer<
  typeof updateWorkerMfaMethodRequestSchema
>;
